import React, { useEffect, useMemo, useState, useRef } from "react";
import { transformData } from "../Utils/transformData"; // Ensure this import is correct
import { getColourSchemeByID } from "../../../Colors/ColorPalettes";

import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import {
  deleteTemporaryFilters,
  getL1SheetProperty,
  getL2SheetProperty,
  getWorkbookProperty,
  removeLevel2Properties,
  setFiltersToOtherSheets,
  setLevel2Properties,
  setWorkbookProperty,
  updateLevel2Properties,
} from "../../../features/reduxworkbook/WorkbookSlice";
import { useDispatch, useSelector } from "react-redux";
import { nanoid } from "@reduxjs/toolkit";
import {
  getSheetControls,
  setSheetControls,
} from "../../../features/reduxworkbook/WorkbookControllingSlice";
import { CalculateAction, handleClicked } from "../../actions/Action";
import { CustomTooltip } from "../Custom/CustomTooltipContent";
import { formatNumber } from "../Utils/FormatNumbers";
import { handleHeirarchy } from "../Utils/HandleHeirarchy";
import {
  adjustOpacity,
  stackedBarChartPosition,
} from "../Utils/ChartsFunctions";
import { useNavigate } from "react-router-dom";
import { CustomLegend } from "../Custom/CustomLegendContent";

const ScatterChartComp = ({
  Data,
  Sheetid,
  rowKeys: rawRowKeys,
  valueKeys,
  toolTipKeys,
  groupByKeys,
  isAnimataionOff,
  vizType,
  filters: filterArray,
  dataSourceID,
}) => {
  // console.log(rawRowKeys);
  // console.log(groupByKeys);
  // console.log(valueKeys);
  // console.log(Data);

  let timer;
  // const reduxActiveIndex = useSelector(
  //   getSheetControls({ Sheetid: Sheetid, key: "activeIndex" })
  // );
  const reduxClickedCaption = useSelector(
    getSheetControls({ Sheetid: Sheetid, key: "clickedCaption" })
  );
  const SufixPrefix = valueKeys.map((item) => item.numberFormat);
  const [clickedCaption, setClickedCaption] = useState(
    (reduxClickedCaption !== undefined && reduxClickedCaption) || []
  );
  const [activeIndex, setActiveIndex] = useState([]);
  const [hoverIndex, setHoverIndex] = useState(null);
  const [clickTimeoutState, setClickTimeoutState] = useState(null);
  const [longestLabelWidth, setLongestLabelWidth] = useState(0);
  //responsive
  // const leftMargin = Math.ceil(longestLabelWidth) + 10;
  // console.log(clickedCaption);

  const customizationObject = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "customization")
  );
  const sheetsArray = useSelector((state) =>
    getWorkbookProperty(state, "sheets")
  );

  const dispatch = useDispatch();

  const getOnClickProperties = useSelector((state) => {
    return getL2SheetProperty(state, Sheetid, "actions", "onClick");
  });
  const getOnDoubleClickProperties = useSelector((state) =>
    getL2SheetProperty(state, Sheetid, "actions", "onDoubleClick")
  );
  const hierarchy =
    useSelector((state) => getWorkbookProperty(state, "hierarchy")) || [];
  const workbookId =
    useSelector((state) => getWorkbookProperty(state, "_id")) || [];
  const workbookType =
    useSelector((state) => getWorkbookProperty(state, "type")) || [];
  const {
    isLabelVisible,
    labelPosition,
    labelFontSize,
    labelFontColor,
    labelRotate,
    pointSize,
    labelShapes,
    isLegendVisible,
    legendAlign,
    legendVerticalAlign,
    legendLayout,
    colorSchemeid,
    isGridVisible,
    isAxeslabelVisible,
    labelAxesFontSize,
    labelAxesFontColor,
    colorMapping,
    isLegendBold,
    legendFontColor,
    isTitleBold,
    Title,
    isTileVisible,
    TitleFontColor,
    TitleSize,
    valueAlign,
  } = customizationObject;

  // console.log(labelShapes);
  // console.log(colorMapping);

  //usememo
  const { data: transformedData, uniqueColumnValues } = useMemo(() => {
    return transformData(Data, groupByKeys, rawRowKeys, valueKeys);
  }, [Data, groupByKeys, rawRowKeys, valueKeys]);
  // console.log(uniqueColumnValues, transformedData);

  // // console.log(Data, groupByKeys, rawRowKeys, valueKeys);
  // // console.log(rawRowKeys);

  const handleScatterMouseEnter = (scatterIndex) => {
    setHoverIndex(scatterIndex);
  };

  const handleScatterMouseLeave = () => {
    setHoverIndex(null);
  };
  const nanoId = nanoid();
  const navigate = useNavigate();
  const handleClickEvent = (data, index, event) => {
    // Check if event is undefined, fallback to window.event if necessary
    // console.log(data);

    const newEvent = event || window.event;
    if (!getOnClickProperties?.action && !getOnDoubleClickProperties?.action) {
      handleClicked({
        data,
        index,
        event,
        requiredArray: groupByKeys,
        hoverIndex,
        dispatch,
        deleteTemporaryFilters,
        setFiltersToOtherSheets,
        Sheetid,
        clickedCaption,
        setClickedCaption,
        activeIndex,
        setActiveIndex,
        vizType,
        dataSourceID,
      });
    } else {
      if (
        getOnClickProperties?.action === "Hierarchy" &&
        valueKeys.length &&
        rawRowKeys[0] &&
        groupByKeys[0]
      ) {
        const rowCurrentValue = rawRowKeys[0]["rename"];
        const groupCurrentValue = groupByKeys[0]["rename"];
        // console.log(data[rowCurrentValue]);
        // console.log(data[groupCurrentValue]);
        let groupFilterItemIs,
          rowFilterItemIs,
          isGroupHierarchyLastItemExist,
          isRowHierarchyLastItemExist,
          groupIsExpandable,
          rowIsExpandable;
        groupFilterItemIs = {
          columnName: groupByKeys[0].columnName,
          dataType: groupByKeys[0].dataType,
          uuid: groupByKeys[0].uuid,
          rename: groupByKeys[0].rename,
          sourceSheetId: Sheetid,
          nanoId: nanoId,
          selectedFilterValues: [data[groupCurrentValue]],
          selectedOperator: "IN",
          filterType: "temporary",
          format: null,
          dataSourceID,
        };
        rowFilterItemIs = {
          columnName: rawRowKeys[0].columnName,
          dataType: rawRowKeys[0].dataType,
          uuid: rawRowKeys[0].uuid,
          rename: rawRowKeys[0].rename,
          sourceSheetId: Sheetid,
          nanoId: nanoId,
          selectedFilterValues: [data[rowCurrentValue]],
          selectedOperator: "IN",
          filterType: "temporary",
          format: null,
          dataSourceID,
        };

        const rowHierarchy = rowCurrentValue
          ? hierarchy.find((item) =>
            item.hierarchyArray.find((arr) => arr.rename === rowCurrentValue)
          )
          : null;
        const groupHierarchy = groupCurrentValue
          ? hierarchy.find((item) =>
            item.hierarchyArray.find(
              (arr) => arr.rename === groupCurrentValue
            )
          )
          : null;
        rowIsExpandable =
          rowHierarchy !== undefined && rowHierarchy !== null ? true : false;
        groupIsExpandable =
          groupHierarchy !== undefined && groupHierarchy !== null
            ? true
            : false;
        isGroupHierarchyLastItemExist =
          groupHierarchy !== undefined &&
          groupHierarchy.hierarchyArray[
          groupHierarchy.hierarchyArray.length - 1
          ]["rename"] === groupCurrentValue;
        isRowHierarchyLastItemExist =
          rowHierarchy !== undefined &&
          rowHierarchy.hierarchyArray[rowHierarchy.hierarchyArray.length - 1][
          "rename"
          ] === rowCurrentValue;
        if (clickTimeoutState) {
          clearTimeout(clickTimeoutState);
          setClickTimeoutState(null);
          // console.log("double clicked");
          handleHeirarchy({
            headerId: groupCurrentValue,
            foundHierachy: groupHierarchy,
            requiredArray: [],
            dispatch: dispatch,
            functionToAddAndUpdate: updateLevel2Properties,
            functionToRemove: removeLevel2Properties,
            Sheetid: Sheetid,
            vizType: vizType,
            functionWillBe: "replaceItemWithNextItem",
            groupHierarchy,
            rowHierarchy,
            rowCurrentValue,
            groupCurrentValue,
            groupIsExpandable,
            rowIsExpandable,
          });
          if (groupIsExpandable && !isGroupHierarchyLastItemExist) {
            dispatch(
              setLevel2Properties({
                reduxKey: "filters",
                Sheetid,
                parentKey: "query",
                value: groupFilterItemIs,
                itemInArray: true,
              })
            );
          }
          if (rowIsExpandable && !isRowHierarchyLastItemExist) {
            dispatch(
              setLevel2Properties({
                reduxKey: "filters",
                Sheetid,
                parentKey: "query",
                value: rowFilterItemIs,
                itemInArray: true,
              })
            );
          }
        } else {
          const timeout = setTimeout(() => {
            setClickTimeoutState(null);
            // console.log("single clicked");
            handleHeirarchy({
              headerId: groupCurrentValue,
              foundHierachy: groupHierarchy,
              requiredArray: [],
              dispatch: dispatch,
              functionToAddAndUpdate: updateLevel2Properties,
              functionToRemove: removeLevel2Properties,
              Sheetid: Sheetid,
              vizType: vizType,
              functionWillBe: "replaceItemWithpreviousItem",
              groupHierarchy,
              rowHierarchy,
              rowCurrentValue,
              groupCurrentValue,
              groupIsExpandable,
              rowIsExpandable,
            });
            const findRemoveAbleItem = (
              hierarchyArray,
              currentIndex,
              filterArray
            ) => {
              // console.log(currentIndex);
              const heirarchyPreivousItemIs =
                hierarchyArray[currentIndex - 1].uuid;
              // console.log(heirarchyPreivousItemIs);
              const filterItemIs = filterArray.find(
                (filterItem) => filterItem.uuid === heirarchyPreivousItemIs
              );
              // console.log(filterItemIs);
              if (filterItemIs) {
                return filterItemIs;
              }
              return undefined;
            };

            const groupCurrentIndex =
              groupHierarchy?.hierarchyArray.findIndex(
                (row) => row.rename === groupCurrentValue
              ) ?? -1;

            const rowCurrentIndex =
              rowHierarchy?.hierarchyArray.findIndex(
                (row) => row.rename === rowCurrentValue
              ) ?? -1;

            const groupRemoveAbleItemIs =
              groupCurrentIndex > 0
                ? findRemoveAbleItem(
                  groupHierarchy.hierarchyArray,
                  groupCurrentIndex,
                  filterArray
                )
                : undefined;

            const rowRemoveAbleItemIs =
              rowCurrentIndex > 0
                ? findRemoveAbleItem(
                  rowHierarchy.hierarchyArray,
                  rowCurrentIndex,
                  filterArray
                )
                : undefined;

            // console.log(groupRemoveAbleItemIs);
            // console.log(rowRemoveAbleItemIs);

            if (groupIsExpandable && groupRemoveAbleItemIs !== undefined) {
              dispatch(
                removeLevel2Properties({
                  reduxKey: "filters",
                  parentKey: "query",
                  value: groupRemoveAbleItemIs,
                  Sheetid,
                  itemInArray: true,
                })
              );
            }
            if (rowIsExpandable && rowRemoveAbleItemIs !== undefined) {
              dispatch(
                removeLevel2Properties({
                  reduxKey: "filters",
                  parentKey: "query",
                  value: rowRemoveAbleItemIs,
                  Sheetid,
                  itemInArray: true,
                })
              );
            }
          }, 250);
          setClickTimeoutState(timeout);
        }
      } else {
        if (timer) {
          //it is a second click
          clearTimeout(timer);
          timer = null;
          // console.log("double");
          CalculateAction({
            data,
            index,
            event: newEvent,
            requiredArray: groupByKeys,
            hoverIndex,
            dispatch,
            deleteTemporaryFilters,
            setFiltersToOtherSheets,
            Sheetid,
            clickedCaption,
            setClickedCaption,
            activeIndex,
            setActiveIndex,
            vizType,
            rawRowKeys: rawRowKeys,
            actionsProperty: getOnDoubleClickProperties,
            setWorkbookProperty,
            workbookId,
            workbookType,
            navigate,
            dataSourceID,
            sheetsArray,
          });
        } else {
          timer = setTimeout(() => {
            // console.log("single");
            CalculateAction({
              data,
              index,
              event: newEvent,
              requiredArray: groupByKeys,
              hoverIndex,
              dispatch,
              deleteTemporaryFilters,
              setFiltersToOtherSheets,
              Sheetid,
              clickedCaption,
              setClickedCaption,
              activeIndex,
              setActiveIndex,
              vizType,
              rawRowKeys: rawRowKeys,
              actionsProperty: getOnClickProperties,
              setWorkbookProperty,
              workbookId,
              workbookType,
              navigate,
              dataSourceID,
              sheetsArray,
            });
            timer = null;
          }, 300);
          // console.log(timer);
        }
      }
    }
  };
  // // console.log(transformedData);
  // // console.log(clickedCaption);
  // // console.log(activeIndex);

  useEffect(() => {
    dispatch(
      setSheetControls({
        Sheetid: Sheetid,
        controls: {
          clickedCaption,
        },
      })
    );
  }, [clickedCaption]);

  const xa = valueKeys[0];
  const yb = valueKeys[1];
  const xAxisCaption = xa?.caption;
  const yAxisCaption = yb?.caption;
  // Custom shape function
  const renderCustomShape = (props) => {
    const {
      data,
      cx,
      cy,
      size,
      shape,
      activeIndex,
      index,
      normalColor,
      fadedColor,
      clickedCaption,
      uniqueColumnValues,
      colorMapping,
    } = props;
    // console.log(uniqueColumnValues);

    const groupCurrentValue =
      groupByKeys[0] !== undefined && groupByKeys[0]["rename"];
    const rowCurrentValue =
      rawRowKeys[0] !== undefined && rawRowKeys[0]["rename"];
    // console.log(rowCurrentValue);

    const requiredObjectIndex = clickedCaption.map((caption) =>
      data.find((f) => f[groupCurrentValue] === caption)
    );
    // console.log(data);

    // console.log(uniqueColumnValues);

    // console.log(clickedCaption);

    // console.log(requiredObjectIndex);

    let fill = normalColor;
    let staticActiveIndexes = [];
    if (clickedCaption.length) {
      staticActiveIndexes = requiredObjectIndex
        .map((clickedItem) =>
          uniqueColumnValues.findIndex(
            (uniqueValues) => uniqueValues === clickedItem[rowCurrentValue]
          )
        )
        .filter((index) => index !== -1); // Optional: Exclude -1 if not found
      // console.log(rowCurrentValue);

      // Ensure unique values
      staticActiveIndexes = [...new Set(staticActiveIndexes)];
    }
    // console.log(uniqueColumnValues);

    // console.log(staticActiveIndexes);
    if (staticActiveIndexes.length === 0) {
      fill = normalColor;
    } else if (staticActiveIndexes.includes(index)) {
      fill = normalColor;
    } else {
      fill = fadedColor;
    }

    switch (shape) {
      case "star":
        const starPoints = (radius, cx, cy) => {
          const points = [];
          const angle = Math.PI / 5;
          for (let i = 0; i < 10; i++) {
            const r = i % 2 === 0 ? radius : radius / 2;
            const x = cx + r * Math.sin(i * angle);
            const y = cy - r * Math.cos(i * angle);
            points.push(`${x},${y}`);
          }
          return points.join(" ");
        };
        return <polygon points={starPoints(size, cx, cy)} fill={fill} />;

      case "circle":
        return <circle cx={cx} cy={cy} r={size} fill={fill} />;

      case "triangle":
        const sideLength = size * Math.sqrt(3);
        const height = (sideLength * Math.sqrt(3)) / 2;
        return (
          <polygon
            points={`
              ${cx},${cy - height / 2}
              ${cx - sideLength / 2},${cy + height / 2}
              ${cx + sideLength / 2},${cy + height / 2}
            `}
            fill={fill}
          />
        );

      case "cross":
        const lineLength = size;
        const strokeWidth = 2;
        return (
          <>
            <line
              x1={cx - lineLength / 2}
              y1={cy}
              x2={cx + lineLength / 2}
              y2={cy}
              stroke={fill}
              strokeWidth={strokeWidth}
            />
            <line
              x1={cx}
              y1={cy - lineLength / 2}
              x2={cx}
              y2={cy + lineLength / 2}
              stroke={fill}
              strokeWidth={strokeWidth}
            />
          </>
        );

      default:
        return <circle cx={cx} cy={cy} r={size} fill={fill} />;
    }
  };

  const colorScheme = getColourSchemeByID(colorSchemeid);
  const COLORS = colorScheme?.colors || [
    "#fc0390",
    "#03fcd7",
    "#f403fc",
    "#fc5203",
    "#2563eb",
    "#82ca9d",
    "#8884d8",
    "#fccf03",
    "#1303fc",
  ];

  const tickFormatter = (tick) => {
    if (typeof tick === "number" || typeof tick === "string") {
      const formattedTick =
        typeof tick === "string" ? tick : formatNumber(tick, SufixPrefix);

      // Create a temporary canvas to measure the text width

      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      context.font = "12px Arial"; // Use the same font as the chart
      const textWidth = context.measureText(formattedTick).width;

      // Update the longest label width based on SufixPrefix mode
      if (SufixPrefix.mode === "Manual") {
        setLongestLabelWidth(
          (prevWidth) => Math.max(prevWidth, textWidth) - 20
        );
      } else {
        setLongestLabelWidth(
          (prevWidth) => Math.max(prevWidth, textWidth) - 10
        );
      }

      return formattedTick;
    }
    return tick;
  };
  // console.log(uniqueColumnValues);
  // axes label in scatter chart
  const { left, top, bottom, right } = stackedBarChartPosition(
    isAxeslabelVisible,
    false,
    SufixPrefix,
    0,
    0,
    false,
    longestLabelWidth,
    {}
  );
  //window resize
  const containerRef = useRef(null);

  const [labelAxesFontSizes, setLabelAxesFontSize] =
    useState(labelAxesFontSize);
  // console.log(labelAxesFontSizes);

  useEffect(() => {
    const updateSizes = () => {
      if (!containerRef.current) return;
      const containerWidth = containerRef.current.offsetWidth;
      const containerHeight = containerRef.current.offsetHeight;
      const maxSize = Math.min(containerWidth, containerHeight) / 2 - 10;
      setLabelAxesFontSize(
        Math.max(10, Math.min(labelAxesFontSize, maxSize * 0.2))
      );
    };

    // Run once on mount
    updateSizes();

    // Attach resize event listener
    window.addEventListener("resize", updateSizes);

    // Use ResizeObserver for better performance
    const resizeObserver = new ResizeObserver(updateSizes);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => {
      window.removeEventListener("resize", updateSizes);
      resizeObserver.disconnect();
    };
  }, [labelAxesFontSize]);
  // console.log(transformedData, Data);

  return (
    <div ref={containerRef} style={{ width: "100%", height: "100%" }}>
      <div style={{ width: "100%", height: isTileVisible ? "5%" : "0%" }}>
        {isTileVisible && (
          <div
            className={`w-auto ${isTitleBold ? "font-bold" : ""} ${valueAlign === "left"
                ? "text-left"
                : valueAlign === "right"
                  ? "text-right"
                  : "text-center"
              }`}
            style={{
              fontSize: TitleSize,
              color: TitleFontColor ?? "#bababa",
            }}
          >
            {Title || " Title..."}
          </div>
        )}
      </div>
      <div style={{ width: "100%", height: isTileVisible ? "95%" : "100%" }}>
        <ResponsiveContainer
          width={isAxeslabelVisible ? "98%" : "100%"}
          height={isAxeslabelVisible ? "98%" : "100%"}
          className="flex items-center justify-center"
        >
          <ScatterChart
            margin={{
              left: left,
              bottom,
              top,
              right,
            }}
          >
            {isGridVisible && <CartesianGrid strokeDasharray="3 3" />}
            <XAxis
              type="number"
              dataKey={xa?.responseKey}
              tick={{ fill: "#909497" }}
              tickFormatter={(value) =>
                valueKeys.length
                  ? tickFormatter(value, SufixPrefix[0], "xAxis")
                  : value
              }
              label={
                isAxeslabelVisible
                  ? {
                    content: ({ viewBox }) => {
                      const { x, y, width } = viewBox;
                      return (
                        <text
                          x={x + width / 2} // Center horizontally
                          y={y + 50} // Adjust as needed
                          textAnchor="middle" // Center text horizontally
                          fill={labelAxesFontColor}
                          dominantBaseline="middle"
                          style={{
                            fontWeight: "normal",
                            fontSize: labelAxesFontSizes,
                          }} // Center text vertically
                        >
                          {xAxisCaption}
                        </text>
                      );
                    },
                  }
                  : null
              }
            />
            <YAxis
              type="number"
              dataKey={yb?.responseKey}
              tick={{ fill: "#909497" }}
              tickFormatter={(value) =>
                valueKeys.length
                  ? tickFormatter(value, SufixPrefix[1], "yAxis")
                  : value
              }
              label={
                isAxeslabelVisible
                  ? {
                    content: ({ viewBox }) => {
                      const { x, y, height } = viewBox;
                      return (
                        <text
                          x={x - 10}
                          y={y + height / 2}
                          textAnchor="middle"
                          fill={labelAxesFontColor}
                          dominantBaseline="middle"
                          transform={`rotate(-90, ${x - 10}, ${y + height / 2
                            })`}
                          style={{
                            fontWeight: "normal",
                            fontSize: labelAxesFontSizes,
                          }}
                        >
                          {yAxisCaption}
                        </text>
                      );
                    },
                  }
                  : null
              }
            />
            {isLegendVisible && (
              <Legend
                iconType="square"
                align={legendAlign.value}
                verticalAlign={legendVerticalAlign.value}
                layout={legendLayout.value}
                fill={legendFontColor}
                legendFontWeight={isLegendBold}
                content={
                  <CustomLegend
                    {...{
                      align: legendAlign.value,
                      verticalAlign: legendVerticalAlign.value,
                      layout: legendLayout.value,
                      valueKeys,
                      legendFontColor,
                      isLegendBold,
                    }}
                  />
                }
              />
            )}
            <Tooltip
              content={
                <CustomTooltip
                  tooltipKeys={toolTipKeys}
                  // toolTipKeys={toolTipKeys}
                  chartType={"scatter"}
                  columnKeys={groupByKeys}
                  valueKeys={valueKeys}
                  SufixPrefix={SufixPrefix}
                  rowKeys={rawRowKeys}
                  colorSchemeid={colorSchemeid}
                  colorMapping={colorMapping}
                />
              }
              headerKeys={uniqueColumnValues}
            // tooltipKeys={toolTipKeys}
            />

            {uniqueColumnValues ? (
              uniqueColumnValues.map((category, index) => {
                // console.log(category, uniqueColumnValues);
                if (!category) {
                  return null;
                }
                // console.log(category, index);
                const filteredArray = transformedData.filter(
                  (row) => row[rawRowKeys[0]?.responseKey] === category
                );
                // console.log(transformedData);
                // console.log(filteredArray);

                const normalColor =
                  colorMapping?.[category] || COLORS[index % COLORS.length];

                const fadedColor = adjustOpacity(normalColor, vizType);
                // console.log(fadedColor);

                return (
                  <Scatter
                    key={category}
                    name={category}
                    // fill={COLORS[index % COLORS.length]}
                    fill={normalColor}
                    data={filteredArray}
                    shape={(props) =>
                      renderCustomShape({
                        ...props,
                        data: transformedData,
                        size: pointSize,
                        shape: labelShapes ? labelShapes.value : null,
                        activeIndex,
                        index,
                        normalColor,
                        fadedColor,
                        clickedCaption,
                        uniqueColumnValues,
                      })
                    }
                    isAnimationActive={isAnimataionOff}
                    onClick={(data, index, event) =>
                      handleClickEvent(data, index, event)
                    }
                    onMouseEnter={() => handleScatterMouseEnter(index)}
                    onMouseLeave={handleScatterMouseLeave}
                  >
                    {isLabelVisible && (
                      <LabelList
                        dataKey={groupByKeys[0]?.responseKey}
                        fontSize={labelFontSize}
                        fill={labelFontColor}
                        stroke={labelFontColor}
                        angle={labelRotate}
                        position={labelPosition.value}
                      />
                    )}
                  </Scatter>
                );
              })
            ) : (
              <Scatter
                fill={COLORS[0]}
                data={transformedData}
                shape={(props) =>
                  renderCustomShape({
                    ...props,
                    data: transformedData,
                    size: pointSize,
                    shape: labelShapes ? labelShapes.value : null,
                    activeIndex,
                    index: 0,
                    normalColor: COLORS[0 % COLORS.length],
                    fadedColor: adjustOpacity(
                      COLORS[0 % COLORS.length],
                      vizType
                    ),
                    clickedCaption,
                    uniqueColumnValues,
                  })
                }
              >
                {isLabelVisible && (
                  <LabelList
                    dataKey={groupByKeys[0]?.responseKey}
                    fontSize={labelFontSize}
                    fill={labelFontColor}
                    // stroke={labelFontColor}
                    stroke={labelFontColor === "white" ? "black" : "white"}
                    angle={labelRotate}
                    position={labelPosition.value}
                    strokeWidth={0.2}
                  />
                )}
              </Scatter>
            )}
          </ScatterChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ScatterChartComp;
